module.exports = __webpack_public_path__ + "img/icon-construction.f93e7c49.svg";